<div class="personal-card-info" #closeDropdownElement>
  <span class="personal-card-arrow">
    <span class="dropdown-menu-arrow"></span>
  </span>

  <input type="file" class="d-none" [files]="null" (change)="handleFileUpload($event)" #fileInput>
  <div class="personal-card-body border-bottom-lightest"
    [ngClass]="{'profile-preview':!isEditable, 'profile-edit': isEditable }">
    <!-- left -->
    <div class="profile border-right-lightest" [ngClass]="{'border-right-lightest': isWorkAsTechEnabled && !isEditable}">
        <div class="personal-card-avatar flex-center-center" [hidden]="!previewImage" [ngClass]="{'image': previewImage}">
          <img [src]="previewImage" [alt]="_user.firstName" *ngIf="previewImage">
          <div class="personal-preview-overlay flex-center-center">
            <i class="fal fa-times font-600" (click)="removeImage()"></i>
          </div>
        </div>
  
        <div class="personal-card-avatar flex-center-center" [hidden]="user.image || isUploading">
          <p class="initials m-0 font-primary">{{initials}}</p>
          <i class="fas fa-camera camera pointer font-primary" (click)="fileInput.click()"></i>
        </div>
  
        <div class="personal-card-preview flex-column flex-center" [hidden]="isEditable">
          <p class="m-0 font-600 font-gray-35 font-14">{{_user.firstName}} {{_user.lastName}}<i class="far fa-edit font-primary font-12 font-400 pointer ml-2" (click)="toggleEditMode()"></i></p>
          <p class="m-0 font-gray-35 font-11">{{_user.phone | mask: '(000) 000 0000' }}</p>
          <p class="m-0 font-gray-35 font-11 word-break-breakall">{{_user.email}}</p>              
          <!-- <p class="mb-1 pt-3 font-primary font-11 text-center underline pointer" (click)="toggleEditMode()">Edit</p> -->
        </div>        
        <div [hidden]="isEditable" *ngIf="showAudibleNotification" class="flex-center-center auditible-notifcation p-2" (click)="handleAudibleNotificationSettings(userHasAudibleNotification)">
          <i [ngClass]="userHasAudibleNotification ? 'fa-volume-up' : 'fa-volume-slash'" class="volume-up-color far"></i>
          <span class="pl-2 font-primary font-11">{{ userHasAudibleNotification ? 'Notification Sound On' : 'Notification Sound Off'}}</span>
        </div>
        <div [hidden]="isEditable" class="flex-center-center auditible-notifcation p-2" (click)="openCommissionEarnedModal()" *ngIf="isCommissionVisibleForTechsServiceWriters">
          <i class="far fa-coins font-primary"></i>
          <span class="pl-2 font-primary font-11">Commission earned</span>
        </div>
        
  
        <div class="flex-column flex-center-center width-100p" [hidden]="!isEditable">
          <div class="mb-2 mt-4 width-100p">
            <app-input [id]="'personal-card-fname'" placeholder="First Name*" label="First Name*" [floatingLabel]="true" [value]="user.firstName"
              [isInvalid]="errors.firstName" [errorMessage]="errors.firstName"
              (appChange)="handleChange('firstName', $event)" (appFocus)="handleFocus('firstName')"
              (appBlur)="handleBlur('firstName')"></app-input>
          </div>
          <div class="mb-2 mt-3 width-100p">
            <app-input [id]="'personal-card-lname'" placeholder="Last Name*" label="Last Name*" [floatingLabel]="true" [value]="user.lastName"
              [isInvalid]="errors.lastName" [errorMessage]="errors.lastName" (appChange)="handleChange('lastName', $event)"
              (appFocus)="handleFocus('lastName')" (appBlur)="handleBlur('lastName')"></app-input>
          </div>
          <div class="mb-2 mt-3 width-100p">
            <app-input [id]="'personal-card-mobile'" placeholder="Mobile*" label="Mobile*" mask="(000) 000-0000" [floatingLabel]="true"
              [value]="user.phone" [isInvalid]="errors.phone" [errorMessage]="errors.phone"
              (appChange)="handleChange('phone', $event)" (appFocus)="handleFocus('phone')" (appBlur)="handleBlur('phone')">
            </app-input>
          </div>
          <div class="mb-4 mt-3 width-100p">
            <app-input [id]="'personal-card-email'" placeholder="Email*" label="Email*" [floatingLabel]="true" [value]="user.email"
              [isInvalid]="errors.email" [errorMessage]="errors.email" (appChange)="handleChange('email', $event)"
              (appFocus)="handleFocus('email')" (appBlur)="handleBlur('email')">
            </app-input>
          </div>
          <div class="personal-action">
            <button (click)="toggleEditMode()" class="btn btn-white btn-submit mr-1 font-12 font-bold font-gray-45">
              Cancel
            </button>
            <button (click)="handleSubmit()" class="btn btn-primary btn-submit mr-1 font-12 font-bold font-white">
              Save
            </button>
          </div>
        </div>      
    </div>
    <!-- right -->
    <div class="profile" *ngIf="isWorkAsTechEnabled">
        <div class="flex-center-center" [hidden]="isEditable">
          <app-clock [datetime]="serverTime" [isMainApp]="true" [tech]="tech" [clockInTime]="clockInTime" [loggedHours]="loggedHours" [isAppswitch]="true"
          [isProcessing]="isProcessing" [showTimeLogPie]="tech?.clockedIn" [startAt]="startOfSession" [endAt]="serverTime"
          [handleClockStatusUpdate]="handleClockStatusUpdate"></app-clock>
        </div>
    </div>
  </div>
  <div class="user-info-footer flex-row" [hidden]="isEditable">
    <button (click)="handleLogout()" class="btn btn-white btn-submit font-12 font-bold font-gray-45">
      Logout
    </button>
    <button *ngIf="isWorkAsTechEnabled" (click)="navigateToTech()" class="btn btn-primary btn-submit font-12 font-bold">
      View as technician
    </button>
  </div>
</div>
